/*! © 2026 Laurent Allègre — AL Consulting Solutions (al-consulting-solutions.fr). Tous droits réservés.
   Code propriétaire : toute reproduction ou réutilisation hors licence écrite est interdite. */
/* Formules (fiche F2) : la carte cochée pilote le formulaire d'achat natif de la
   section (champ id, libellé et état du bouton) et la barre d'achat collante.
   Sans JavaScript, le produit courant reste coché et le formulaire l'ajoute. */
(() => {
  const init = (set) => {
    if (set.dataset.formulesReady === 'true') return;
    const form = document.querySelector(`product-form-component[data-section-id="${set.dataset.formulesSection}"]`);
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    set.dataset.formulesReady = 'true';

    const button = form.querySelector('[ref="addToCartButton"]');
    const labelNode = button
      ? Array.from(button.childNodes).find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim())
      : null;
    const initialLabel = labelNode ? labelNode.textContent.trim() : '';
    const withPrice = initialLabel.includes(' · ');
    const baseLabel = withPrice ? initialLabel.split(' · ')[0] : (initialLabel || set.dataset.addLabel);
    const sticky = document.querySelector('sticky-add-to-cart');

    const apply = (input) => {
      const available = input.dataset.available === 'true';
      set.querySelectorAll('.pa-formule').forEach((li) => li.classList.toggle('pa-formule--on', li.contains(input)));

      idInput.value = input.value;

      if (button) {
        button.disabled = !available;
        if (labelNode) {
          const text = !available ? set.dataset.soldOutLabel : withPrice ? `${baseLabel} · ${input.dataset.price}` : baseLabel;
          labelNode.textContent = labelNode.textContent.replace(labelNode.textContent.trim(), text);
        }
      }

      if (sticky) {
        const title = sticky.querySelector('.sticky-add-to-cart__title');
        if (title) title.textContent = input.dataset.title;
        const price = sticky.querySelector('.sticky-add-to-cart__price');
        const tpl = input.closest('.pa-formule')?.querySelector('template.pa-formule__sticky-price');
        if (price && tpl) price.replaceChildren(tpl.content.cloneNode(true));
        const img = sticky.querySelector('[ref="productImage"]');
        if (img && input.dataset.image) {
          img.src = input.dataset.image;
          img.removeAttribute('srcset');
        }
        const stickyButton = sticky.querySelector('[ref="addToCartButton"]');
        if (stickyButton) stickyButton.disabled = !available;
        sticky.dataset.variantAvailable = String(available);
      }
    };

    set.addEventListener('change', (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.classList.contains('pa-formule__input')) apply(input);
    });

    // Retour arrière / bfcache : le navigateur peut restaurer une autre case cochée.
    const checked = set.querySelector('.pa-formule__input:checked');
    if (checked && checked.dataset.current !== 'true') apply(checked);
  };

  const scan = (root) => root.querySelectorAll('.product-alternative__formules-set').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  window.addEventListener('pageshow', (event) => { if (event.persisted) scan(document); });
})();
